export default [
  {
    path: "/locationPayment",  //扫码创建
    name: 'locationPayment',
    meta: {
      keepAlive: false // 需要缓存
    },
    component: () => import("@/views/payment/locationPayment.vue")
  }
]
